const MessageType = {
  Announcement: "announcement",
};

export default MessageType;
